<template>
  <base-dialog :visible.sync="visible" show-close>
    <template v-slot:header>设置字段权限</template>
    <div class="details-setting">
      <div class="setting-list">
        <el-row class="setting-item header">
          <el-col :span="12" style="padding: 0 20px;font-size: 14px;">
            字段
          </el-col>
          <el-col :span="12">
            <el-checkbox v-model="fieldPrisAll" :indeterminate="indeterminate" @change="setAll">
              编辑
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row v-for="item in fields" :key="item.pri" class="setting-item">
          <el-col :span="12" style="padding: 0 20px;">
            {{ item.name }}
          </el-col>
          <el-col :span="12">
            <el-checkbox v-model="item.checked" @change="setOne"></el-checkbox>
          </el-col>
        </el-row>
      </div>
    </div>
    <template v-slot:footer>
      <base-button type="primary" @click="submit">保存</base-button>
      <base-button @click="visible = false">取消</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import { checkPermission, permissionList, transFieldsPri } from "@/utils/project"

export default {
  name: "setting-field-pri",
  components: { BaseDialog, BaseButton },
  computed: {
    indeterminate() {
      return Boolean(this.selectedFieldsCount && this.selectedFieldsCount < this.fields.length)
    },
    selectedFieldsCount() {
      return this.fields.filter(f => f.checked).length
    },
    curPriCode() {
      return transFieldsPri(this.fields)
    }
  },
  data() {
    return {
      visible: false,
      fieldPrisAll: false,
      fieldPris: {},
      fields: permissionList
        .filter(p => p.isField)
        .map(({ name, value }) => ({
          name,
          pri: value,
          checked: false
        }))
    }
  },
  methods: {
    open(priCode) {
      // 初始化字段权限
      let allChecked = true
      this.fields.forEach(field => {
        field.checked = checkPermission(priCode, field.pri)
        allChecked = allChecked && field.checked
      })
      this.fieldPrisAll = allChecked

      this.visible = true
    },
    setOne() {
      if (this.selectedFieldsCount === this.fields.length) {
        this.fieldPrisAll = true
      }
    },
    setAll(checked) {
      this.fields.forEach(field => (field.checked = checked))
    },
    submit() {
      this.$emit("submit", this.curPriCode)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.details-setting {
  .setting-list {
    .setting-item {
      color: #333;
      height: 40px;
      line-height: 40px;
      &:not(:first-child) {
        border-bottom: 1px solid #ddd;
      }
    }
    .header {
      font-weight: bold;
      background-color: #ededed;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>
